import Header from '../common/Header';
import Footer from '../common/Footer';
import SeoHelmet from '../common/SeoHelmet';

const TermsOfUse = () => {
  return (
    <>
      <SeoHelmet
        title="GeoCalc | Terms of Use"
        description="Terms governing your use of GeoCalc.app, including account and subscription rules, acceptable use, intellectual property, service changes, disclaimers, and liability limits."
        url="https://www.geocalc.app/terms-of-use"
        image="https://www.geocalc.app/assets/og-theory-v1.jpg"
        schemaType="page"
        breadcrumbs={[
          { name: 'Home', url: 'https://www.geocalc.app/' },
          { name: 'Terms of Use', url: 'https://www.geocalc.app/terms-of-use' },
        ]}
      />

      <Header />
      <div className="privacyPolicy">
        <h1>Terms of Use</h1>
        <p>
          These Terms of Use (“Terms”) govern your access to and use of GeoCalc.app and its calculation tools (the “Service”). By
          using the Service, you agree to these Terms.
        </p>

        <h2>1) Who we are</h2>
        <p>“GeoCalc”, “we”, or “us” refers to the operator of GeoCalc.app. Contact: info@geocalc.app.</p>

        <h2>2) Eligibility and accounts</h2>
        <p>
          You must be able to form a binding contract. If you create an account, you are responsible for keeping credentials
          confidential and for all activity under your account.
        </p>

        <h2>3) Subscriptions, payments, and refunds</h2>
        <p>
          Paid features may be offered on a subscription basis. Payments are processed by Polar (Polar.sh) as our payment
          processor. Applicable pricing, billing intervals, renewal terms, and any refund policies are shown at purchase time. If
          a renewal is enabled, the subscription renews automatically until cancelled in your Polar customer portal or within the
          Service (where available). Billing issues should be directed to info@geocalc.app.
        </p>

        <h2>4) Acceptable use</h2>
        <p>
          You will not: (a) reverse engineer, decompile, or scrape the Service; (b) bypass technical limits; (c) upload malware;
          (d) use the Service to produce unlawful, misleading, or infringing outputs; or (e) misrepresent results as site-sealed
          or certified engineering deliverables.
        </p>

        <h2>5) No professional advice</h2>
        <p>
          The Service provides computational tools and references. It does not replace professional judgment, site investigation,
          code compliance checks, or peer review. You are solely responsible for verifying inputs, assumptions, and outputs before
          use in practice.
        </p>

        <h2>6) Intellectual property</h2>
        <p>
          The Service, including calculators, UI, text, and media, is owned by GeoCalc and its licensors and protected by law.
          Subject to these Terms, we grant you a limited, revocable, non-transferable license to use the Service for your internal
          purposes. You retain rights in your inputs and reports you generate, except for components we own or license.
        </p>

        <h2>7) Third-party services</h2>
        <p>
          We may integrate third-party services (e.g., payment processing by Polar). Those services are governed by their own
          terms and privacy policies.
        </p>

        <h2>8) Availability and changes</h2>
        <p>
          We may modify, suspend, or discontinue the Service, features, or pricing at any time. Where materially adverse, we will
          use reasonable efforts to give notice.
        </p>

        <h2>9) Termination</h2>
        <p>
          You may stop using the Service at any time. We may suspend or terminate access if you breach these Terms, cause risk, or
          where required by law. Sections that by nature should survive (e.g., IP, disclaimers, liability limits, governing law)
          survive termination.
        </p>

        <h2>10) Disclaimers</h2>
        <p>
          The Service is provided “as is” and “as available”. To the maximum extent permitted by law, we disclaim all warranties,
          express or implied, including fitness for a particular purpose, accuracy, and non-infringement.
        </p>

        <h2>11) Limitation of liability</h2>
        <p>
          To the maximum extent permitted by law, GeoCalc shall not be liable for any indirect, incidental, special,
          consequential, exemplary, or punitive damages, or for loss of profits, data, or goodwill, arising out of or related to
          your use of the Service. GeoCalc’s total liability for any claim shall not exceed the amounts (if any) you paid for the
          Service in the twelve (12) months preceding the event giving rise to the claim.
        </p>

        <h2>12) Indemnity</h2>
        <p>You will indemnify GeoCalc against claims arising from your misuse of the Service or violation of these Terms.</p>

        <h2>13) Governing law and venue</h2>
        <p>
          These Terms are governed by the laws of the Republic of Türkiye, without regard to conflict-of-law principles. Exclusive
          jurisdiction and venue lie in the competent courts of İzmir, Türkiye.
        </p>

        <h2>14) Changes to these Terms</h2>
        <p>
          We may update these Terms from time to time. Material changes will be posted on this page with an updated effective
          date. Your continued use of the Service after changes take effect constitutes acceptance.
        </p>

        <h2>15) Contact</h2>
        <p>Questions: info@geocalc.app</p>
        <p>
          <strong>Effective date:</strong> 15/Otober/2025
        </p>
      </div>
      <Footer />
    </>
  );
};

export default TermsOfUse;
